import { Injectable } from '@angular/core';
import { GlobalLoaderService } from './global-loader.service';
import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpRequest,
  HttpResponse
} from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class GlobalLoaderInterceptorService {
  private requests: HttpRequest<any>[] = [];
  urlCheck = '';
  debugHttp = true;

  constructor(
    private loaderService: GlobalLoaderService,
  ) {}

  removeRequest(req: HttpRequest<any>) {
    const i = this.requests.indexOf(req);
    if (i >= 0) {
      this.requests.splice(i, 1);
    }
    this.loaderService.isLoading.next(this.requests.length > 0);
  }

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    this.requests.push(req);
    this.loaderService.isLoading.next(true);

    return new Observable(observer => {
      const subscription = next
        .handle(req)
        .subscribe(
          (event: HttpEvent<any>) => {
            if (event instanceof HttpResponse) {
              this.removeRequest(req);
              observer.next(event);
            }
          },
          (error: HttpErrorResponse) => {
            this.removeRequest(req);
            observer.error(error);
          },
          () => {
            this.removeRequest(req);
            observer.complete();
          }
        );
      // remove request from queue when cancelled
      return () => {
        this.removeRequest(req);
        subscription.unsubscribe();
      };
    });
  }
}
